<div class="modal-header">
    <h4 class="modal-title" id="modal-title">
        {{ 'customVendorReporting.instructions.title' | cxTranslate }}
    </h4>
    <button type="button" class="close" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="instructionsParagraph"
            [innerHTML]="'customVendorReporting.instructions.informationParagraph' | cxTranslate">
        </div>
        <div class="importParagraph">
            <p>{{'customVendorReporting.instructions.importCsvParagraphTitle' | cxTranslate }}</p>
            <p>{{ 'customVendorReporting.instructions.importCsvParagraph' | cxTranslate }}
            <p [innerHTML]="'customVendorReporting.instructions.importCsvParagraphContinued' | cxTranslate"></p>
            <div [innerHTML]="'customVendorReporting.instructions.importCsvParagraphAfterTemplate' | cxTranslate"></div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel click')">
        {{ 'customVendorReporting.instructions.close' | cxTranslate }}
    </button>
</div>
